import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../Controller/CreateJobCommentController";
import CommentTemplateService from "../../../Setup/controller/CommentTemplateController/CommentTemplateController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Draggable from 'react-draggable';
import SunTextEditor from "../../../Common/SunTextEditor";
import 'react-quill/dist/quill.snow.css';

function CreateAggNotification({ jobComment, onClose, onSuccess, JobID }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { theme } = useContext(ThemeContext);

    const [formData, setFormData] = useState({
        IssueID: JobID,
        Comment: "",
        CommentType: "0",
        vc_ServiceCode: ""

    });

    const [errors, setErrors] = useState({});
    const [commentTemplatesData, setCommentTemplatesData] = useState([]);
    const [selectedTemplateID, setSelectedTemplateID] = useState("");

    // Apply theme classes
    const accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";

    // ✅ Load jobComment when editing
    useEffect(() => {
        if (jobComment) {
            setFormData({
                IssueID: JobID,
                Comment: jobComment.Comment,
                CommentType: jobComment.CommentType,
                vc_ServiceCode: jobComment.vc_ServiceCode,
            });
        } else {
            setFormData({ IssueID: JobID, Comment: "", CommentType: "0", vc_ServiceCode: "0" });
        }
    }, [jobComment, JobID]);

    // ✅ Fetch comment templates on mount
    useEffect(() => {
        const fetchCommentTemplates = async () => {
            try {
                const redirectCallback = () => navigate('/');
                const templates = await CommentTemplateService.GetAllCommentTemplates(redirectCallback);
                setCommentTemplatesData(templates);
            } catch (error) {
                console.error("Error fetching comment templates:", error);
            }
        };
        fetchCommentTemplates();
    }, [navigate]);

    // ✅ Handle Template Type Change (Add New / Select Template)
    const handleFieldChange = (e) => {
        const { name, value } = e.target;
        handleChange(e, formData, setFormData);

        // Reset selected template when switching between Add New / Templates
        if (name === "CommentType" && value === "0") {
            setSelectedTemplateID("");
            setFormData((prev) => ({ ...prev, Comment: "" }));
        }
    };

    // ✅ Handle selecting a predefined template
    const handleTemplateSelect = (e) => {
        const selectedID = e.target.value;
        setSelectedTemplateID(selectedID);

        // ✅ Update vc_ServiceCode in formData as well
        setFormData((prev) => ({
            ...prev,
            vc_ServiceCode: selectedID
        }));

        if (!selectedID) {
            setFormData((prev) => ({ ...prev, Comment: "" }));
            return;
        }

        const selectedTemplate = commentTemplatesData.find(
            (t) => t.ID.toString() === selectedID
        );
        if (selectedTemplate) {
            setFormData((prev) => ({
                ...prev,
                Comment: selectedTemplate.vc_Comment
            }));
        }
    };

    // ✅ Handle Editor content change
    const handleEditorChange = (content) => {
        setFormData((prev) => ({ ...prev, Comment: content }));
    };

    // ✅ Submit Form
    const handleFormSubmit = async (event) => {
        event.preventDefault(); // Prevent default form submission
        if (jobComment) {
            formData.ID = jobComment.ID;
        } else {
            formData.ID = 0;
        }
        formData.IssueID = JobID;
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/JobsList?saved=true');
        };

        const response = await handleSubmit(event, formData, setFormData, setErrors);
        if (response.data.message === "User added successfully") {
            let JobCostID = localStorage.getItem('JobCostID');
            JobCostID = JobCostID + 1;
            localStorage.setItem('JobCostID', JobCostID);
            onSuccess(); // Call onSuccess to reload data
        }

        // redirectUserList();


    };

    const handleStart = (e) => e.stopPropagation();

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade jobCommentModal show d-block" id="jobCommentModal" tabIndex="-1" aria-labelledby="jobCommentModalLabel" aria-hidden="true" data-backdrop="static">

                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-header" onStart={handleStart}
                            cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p"
                            bounds={{ top: 0, bottom: window.innerHeight - 400 }}>
                            <div className="modal-content">
                                <div className={`modal-header ${accordTheme}`}>
                                    <h5 className="modal-title" id="largeModalLabel">{jobComment ? "Edit Comment" : "Add Comment"}</h5>
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body" style={{ "maxHeight": "300px", "overflow": "auto" }}>
                                    <div className="row mb-3" style={{ marginLeft: "5px", marginRight: "5px", marginTop: "10px" }}>
                                        <table style={{ width: "100%" }}>
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: "13%" }}>
                                                        <label htmlFor="Name" style={{ float: "right" }}>Select Type <span style={{ "color": "red" }}>*</span></label>
                                                    </td>
                                                    <td style={{ width: "37%" }}>
                                                        <select
                                                            className="form-control"
                                                            name="CommentType"
                                                            value={formData.CommentType}
                                                            onChange={handleFieldChange}
                                                        >
                                                            <option value="0">Add New</option>
                                                            <option value="1">Select from Templates</option>
                                                        </select>

                                                    </td>
                                                    <td style={{ width: "13%" }}></td>
                                                    <td style={{ width: "37%" }}></td>

                                                </tr>
                                                {formData.CommentType > 0 && (
                                                    <tr>
                                                        <td>
                                                            <label htmlFor="Name" style={{ float: "right" }}>Select Template <span style={{ "color": "red" }}>*</span></label>
                                                        </td>
                                                        <td>
                                                            <select
                                                                className="form-control"
                                                                value={formData.vc_ServiceCode}
                                                                onChange={handleTemplateSelect}
                                                                name="vc_ServiceCode"
                                                            >
                                                                <option value="">{t("-- Select --")}</option>
                                                                {commentTemplatesData.map((temp) => (
                                                                    <option key={temp.ID} value={temp.ID}>
                                                                        {temp.vc_ServiceCode || temp.vc_Title || `Template #${temp.ID}`}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </td>
                                                        <td></td>
                                                        <td></td>

                                                    </tr>
                                                )}
                                                <tr>

                                                    <td colSpan={4}>

                                                        <SunTextEditor
                                                            value={formData.Comment}
                                                            onChange={(content) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    Comment: content,
                                                                }))
                                                            }
                                                        />
                                                        {errors.Comment && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.Comment}</div>}

                                                    </td>

                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-primary">
                                        <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />
                                        {jobComment ? " Update" : " Save"}

                                    </button>
                                    <button className="btn btn-danger" type="button" aria-label="Close" onClick={onClose}>
                                        <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                                    </button>
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>

            </form>
        </div>
    );
}

export default CreateAggNotification;
